import React from 'react';

import { Svg, Path, SvgProps } from 'react-native-svg';

import { colors } from '@/constants/colors';

const ChairIcon: React.FC<SvgProps> = (props) => {
  const {
    width = '100%',
    height = '100%',
    color = colors.white.primary,
    ...rest
  } = props;

  return (
    <Svg
      enable-background={'new 0 0 55 88'}
      viewBox={'0 0 55 88'}
      width={width}
      height={height}
      {...rest}
    >
      <Path
        fill={color}
        d={
          'm7.94891 0c-4.04672.545985-6.985406 3.46594-7.94891 4.85766 1.4854 4.77738 4.49635 14.42844 4.65693 14.81384.16059.3854.36132.4015.44161.3613.49513 5.1521 1.54161 15.9781 1.76642 18.0657.22482 2.0876.44161 8.0694.5219 10.7993l-3.85401 39.1022h3.89416l4.81749-39.1022 30.5511-1.4854v31.5146l.4818.9234 3.9343-.1606v-32.438l1.8467-.0803v39.1825l.7226 1.0037 4.3358-.3613v-47.0511c0-1.2044-.3613-.9234-1.1642-1.0037-1.2847-6.1825-28.1424-2.8102-33.0402-2.7299-3.9182.0963-6.8248.3881-7.7883.5219-.5754-5.0317-1.7905-15.5526-2.0475-17.3832 1.7022 0 2.7434-.2944 3.0511-.4416-.9367-3.8407-3.2839-12.99931-5.17879-18.9088z'
        }
      />
    </Svg>
  );
};

export default ChairIcon;
